import { IRentedPropertyDetail } from "../types/ownerDashboard.types";
import { normalizeKenloPropertyId } from "./buildPropertyLabelMap";
import { normalizeRentedPropertiesDetails } from "./normalizeRentedPropertiesDetails";

export interface RentedPropertyCatalog {
  byPropertyId: Map<number, IRentedPropertyDetail>;
  byKenloPropertyId: Map<string, IRentedPropertyDetail>;
  findByPropertyId: (propertyId: number | null | undefined) => IRentedPropertyDetail | null;
  findByKenloPropertyId: (
    kenloPropertyId: string | number | null | undefined
  ) => IRentedPropertyDetail | null;
}

export function buildRentedPropertyCatalog(
  details: IRentedPropertyDetail[] | null | undefined
): RentedPropertyCatalog {
  const byPropertyId = new Map<number, IRentedPropertyDetail>();
  const byKenloPropertyId = new Map<string, IRentedPropertyDetail>();

  normalizeRentedPropertiesDetails(details).forEach((detail) => {
    byPropertyId.set(detail.property_id, detail);

    const kenloPropertyId = normalizeKenloPropertyId(detail.kenlo_property_id);
    if (kenloPropertyId) {
      byKenloPropertyId.set(kenloPropertyId, detail);
    }
  });

  return {
    byPropertyId,
    byKenloPropertyId,
    findByPropertyId(propertyId) {
      if (propertyId == null || !Number.isFinite(propertyId)) {
        return null;
      }

      return byPropertyId.get(propertyId) ?? null;
    },
    findByKenloPropertyId(kenloPropertyId) {
      const normalized = normalizeKenloPropertyId(kenloPropertyId);
      if (!normalized) {
        return null;
      }

      return byKenloPropertyId.get(normalized) ?? null;
    },
  };
}
